/**
 * Phase 3 - Spanish translations module (default locale)
 * Loaded dynamically. Merge: EN base + ES overlay.
 */
import enBase from './en.js';
import { translationsEs } from '../../utils/translations/translations.es.js';
import { plansTranslationsEs } from '../../utils/translations/plans/plansTranslations.es.js';

const merged = { ...enBase, ...translationsEs, ...plansTranslationsEs };
export default merged;
